export interface CrmBoardTemplateColuna {
  nome: string;
  cor: string;
  is_ganho?: boolean;
  is_perdido?: boolean;
}

export interface CrmBoardTemplate {
  id: string;
  nome: string;
  descricao: string;
  colunas: CrmBoardTemplateColuna[];
}

// Mesma paleta de cores já usada como sugestão em CrmBoardView.tsx (CORES_SUGERIDAS).
// Só o template "Funil de Vendas" usa is_ganho/is_perdido — essas flags disparam a
// notificação "Negócio ganho!"/"Negócio perdido" e fecham data_fechamento, texto fixo que não
// faz sentido num card de Suporte/Onboarding "concluído" (decisão deliberada de não marcar
// nenhuma coluna desses outros templates com essas flags).
export const CRM_BOARD_TEMPLATES: CrmBoardTemplate[] = [
  {
    id: 'funil-vendas',
    nome: 'Funil de Vendas',
    descricao: 'Lead, Qualificação, Proposta, Negociação, Ganho, Perdido',
    colunas: [
      { nome: 'Lead', cor: '#6b7280' },
      { nome: 'Qualificação', cor: '#3b82f6' },
      { nome: 'Proposta', cor: '#a855f7' },
      { nome: 'Negociação', cor: '#f59e0b' },
      { nome: 'Ganho', cor: '#22c55e', is_ganho: true },
      { nome: 'Perdido', cor: '#ef4444', is_perdido: true },
    ],
  },
  {
    id: 'suporte',
    nome: 'Suporte ao Cliente',
    descricao: 'Novo, Em Atendimento, Aguardando Cliente, Resolvido',
    colunas: [
      { nome: 'Novo', cor: '#6b7280' },
      { nome: 'Em Atendimento', cor: '#3b82f6' },
      { nome: 'Aguardando Cliente', cor: '#f59e0b' },
      { nome: 'Resolvido', cor: '#22c55e' },
    ],
  },
  {
    id: 'onboarding',
    nome: 'Onboarding de Clientes',
    descricao: 'Boas-vindas, Configuração, Treinamento, Concluído',
    colunas: [
      { nome: 'Boas-vindas', cor: '#6b7280' },
      { nome: 'Configuração', cor: '#3b82f6' },
      { nome: 'Treinamento', cor: '#a855f7' },
      { nome: 'Concluído', cor: '#22c55e' },
    ],
  },
  {
    id: 'em-branco',
    nome: 'Em branco',
    descricao: 'Comece do zero e adicione as colunas que quiser',
    colunas: [],
  },
];
